import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle-maintenance.dto';
export * from './dtos/update-vehicle-maintenance.dto';
export * from './dtos/vehicle-maintenance-links.dto';
export * from './dtos/vehicle-maintenance-list.dto';
export * from './dtos/vehicle-maintenance-record.dto';
export * from './dtos/vehicle-maintenance-search.dto';
export * from './dtos/vehicle-maintenances-stats.dto';

export * from './enums/vehicle-maintenance-record-category.enum';
export * from './enums/vehicle-maintenance-status.enum';
export * from './enums/vehicle-maintenance-action.enum';

export * from './functions/vehicle-maintenance-status-to-color.function';

export * from './types/vehicle-maintenances-filters';

export * from './validators/schemas/create-vehicle-maintenance.schema';
export * from './validators/schemas/update-vehicle-maintenance.schema';

export const vehicleMaintenanceValidators = {
	canCreateOrUpdate,
	canPerformAction,
};
